import { getRestrictedStreamingKeysForVideoGroupSet } from "api/schema/stream/getRestrictedStreamingKeysForVideoGroupSet";
import { useStreamApiClient } from "api/useSpwnApiClient";
import useSWR from "swr";

import type { GetRestrictedStreamingKeysForVideoGroupSetResponse } from "api/schema/stream/getRestrictedStreamingKeysForVideoGroupSet";
import type { SWRResponse } from "swr";

const generateKey = ({
  eventId,
  videoGroupSetId,
  code,
}: {
  eventId: string;
  videoGroupSetId: string;
  code: string;
}) => ({
  path: getRestrictedStreamingKeysForVideoGroupSet.path,
  eventId,
  videoGroupSetId,
  code,
});

type UseGetRestrictedStreamingKeysForVideoGroupSet = (args: {
  eventId?: string;
  videoGroupSetId?: string;
  code?: string;
}) => SWRResponse<GetRestrictedStreamingKeysForVideoGroupSetResponse>;

/**
 * videoGroupSet 単位の関係者限定配信で、配下の全 video の署名付き Cookie を一括取得する。
 */
export const useGetRestrictedStreamingKeysForVideoGroupSet: UseGetRestrictedStreamingKeysForVideoGroupSet =
  ({ eventId, videoGroupSetId, code }) => {
    const apiClient = useStreamApiClient();
    return useSWR(
      // 必須パラメータが揃わない場合は fetch しない（未指定での無効化を意図した呼び出しに対応）
      eventId && videoGroupSetId && code
        ? generateKey({
            eventId,
            videoGroupSetId,
            code,
          })
        : null,
      async ({ eventId, videoGroupSetId, code }) => {
        const res = await apiClient.call(
          "getRestrictedStreamingKeysForVideoGroupSet",
          {
            eventId,
            videoGroupSetId,
            code,
          }
        );
        if (!res.ok) {
          throw new Error("API error occurred.");
        }
        return res.data;
      }
    );
  };
